
export default {
    setValue(dom, val){
        let _dom = dom.get(0);
        if(!_dom) {
          return
        }
        if(_dom.tagName == "DIV"){
            $(_dom).html(val);
        }
        if(_dom.tagName == "P"){
            $(_dom).text(val);
        }
        if(_dom.tagName == "SPAN"){
            $(_dom).text(val);
        }
        if(_dom.tagName == "INPUT"){
            $(_dom).val(val);
        }
        if(_dom.tagName == "H3"){
            $(_dom).val(val);
        }
    }
}